export default "__VITE_ASSET__y1XxUu_n__"